/**
 * Empty
 * Vuexの雛形モジュール
 */
export default {
  // 名前空間を付与する
  namespaced: true,

  /* state: Storeの状態 */
  state: {
    // 選択されたid
    selectId: '',
    selectItemKki: '',
    selectKkiCd: '',
    userName: '',
    loginFlg: false
  },

  /* getters: Storeの算出プロパティ
   * Ex. this.$store.getters['userInfo/id']
   */
  getters: {
    // idを取得する
    selectId: state => state.selectId,
    selectItemKki: state => state.selectItemKki,
    selectKkiCd: state => state.selectKkiCd,
    userName: state => state.userName,
    loginFlg: state => state.loginFlg
  },

  /* mutations: stateを同期処理で変更する */
  mutations: {
    // 選択されたidをstate.selectIdに保存する
    saveId (state, payload) {
      state.selectId = payload
    },
    // idを初期化
    removeId (state) {
      state.selectId = ''
    },

    // 選択されたselectKkiをstate.selectItemKkiに保存する
    saveItemKki (state, payload) {
      state.selectItemKki = payload
    },
    // idを初期化
    removeItemKki (state) {
      state.selectItemKki = ''
    },

    // 選択されたkki_cdをstate.selectKkiCdに保存する
    saveKkiCd (state, payload) {
      state.selectKkiCd = payload
    },
    // kki_cdを初期化
    removeKkiCd (state) {
      state.selectKkiCd = ''
    },

    // ポップアップに表示するユーザ名を登録
    saveUserName (state, payload) {
      state.userName = payload
    },

    // loginFlgを変更する
    trueLogin (state) {
      state.loginFlg = true
    },
    falseLogin (state) {
      state.loginFlg = false
    }
  },

  /* actions: mutationを同期/非同期処理でコミットする
   * Ex. this.$store.dispatch('userInfo/setId', payload)
   */
  actions: {
    // 選択されたidを保存する
    selectItem ({ commit }, payload) {
      if (payload) {
        commit('saveId', payload)
      }
    },
    resetId ({ commit }) {
      commit('removeId')
    },

    // 選択されたkki_cd(イベントに使用)を保存する
    selectItemKki ({ commit }, payload) {
      if (payload) {
        commit('saveItemKki', payload)
      }
    },
    resetItemKki ({ commit }) {
      commit('removeItemKki')
    },

    // 選択されたkki_cd(QuickSight)を保存する
    selectKki ({ commit }, payload) {
      if (payload) {
        commit('saveKkiCd', payload)
      }
    },
    resetKki ({ commit }) {
      commit('removeKkiCd')
    },

    // 更新されたuserNameを保存する
    resaveUserName ({ commit }, payload) {
      if (payload) {
        commit('saveUserName', payload)
      }
    },

    // loginしているか否かを保存する
    tLogin ({ commit }) {
      commit('trueLogin')
    },
    fLogin ({ commit }) {
      commit('falseLogin')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/appSetting.js